export function isInsideRectangle(
  x: number,
  y: number,
  left: number,
  right: number,
  top: number,
  bottom: number
) {
  return x >= left && x <= right && y >= top && y <= bottom;
}

export const isInsideSafeTriangle = (
  x: number,
  y: number,
  x1: number,
  y1: number,
  x2: number,
  y2: number,
  x3: number,
  y3: number
) => {
  const denominator = (y2 - y3) * (x1 - x3) + (x3 - x2) * (y1 - y3);
  const u = ((y2 - y3) * (x - x3) + (x3 - x2) * (y - y3)) / denominator;
  const v = ((y3 - y1) * (x - x3) + (x1 - x3) * (y - y3)) / denominator;
  const w = 1 - u - v;

  return u >= 0 && v >= 0 && w >= 0 && u <= 1 && v <= 1 && w <= 1;
};

/**
 * Determine if an HTML element has is overflowing its bounding
 * @param el HTMLElement
 * @returns
 */
export function isEllipsisActive(e: HTMLElement) {
  return e.offsetWidth < e.scrollWidth;
}

export const localeNumber = (
  value: number,
  formatter?: (formatted: string) => string,
  options = {}
): string => {
  if (typeof value !== "number" || Number.isNaN(value)) {
    return "-";
  }

  const formattedValue = value.toLocaleString(undefined, options);

  return typeof formatter === "function"
    ? formatter(formattedValue)
    : formattedValue;
};

export const localeMoney = (
  value: number,
  formatter?: (formatted: string) => string
) =>
  localeNumber(value, formatter, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
